import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=47d5e2a0&"
import script from "./RegisterComponent.vue?vue&type=script&lang=js&"
export * from "./RegisterComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports